import React from "react";
import {
  Dialog,
  DialogTitle,
  Card,
  CardContent,
  DialogContent,
  CardActions,
  Button,
  Typography,
} from "@mui/material";
import i18next from "i18next";


const CustomPopup = ({
  open,
  onClose,
  heading,
  buttonText,
  payload,
  onRegisterDomain,
}) => {
  console.log('domain payload inside modal', payload);
  const isArabic = i18next.language === 'ar';
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth >
      <DialogTitle sx={{ textAlign:  !isArabic ? "left" :"right"}}>{i18next.t(heading)}</DialogTitle>
      <DialogContent>
        <Card
          sx={{
            backgroundColor: "white",
            borderRadius: "8px",
            boxShadow: "0px 48px 64px 0px #33333326",
            padding: "24px",
            textAlign:  !isArabic ? "left" :"right",
            cursor: "pointer",
            width: "95%",
          }}
        >
          <CardContent>
            <Typography
              sx={{
                fontSize: "32px",
                fontFamily: "Tajawal-Bold",
                color: "#3173B1",
                fontWeight: 700,
              }}
            >
              {i18next.t("Available")}: {payload?.isAvailbility ? "Yes" : "No"}
            </Typography>
            <Typography
              sx={{
                fontSize: "32px",
                fontFamily: "Tajawal-Bold",
                color: "#3173B1",
                fontWeight: 700,
              }}
            >
              {payload?.domain}
            </Typography>
            <Typography
              sx={{
                fontSize: "16px",
                fontFamily: "Tajawal-Regular",
                color: "#808080",
              }}
            >
              {i18next.t(payload?.description)}
            </Typography>
            <Typography
              sx={{
                fontSize: "40px",
                color: "#2E2E2E",
                fontWeight: 700,
                fontFamily: "Tajawal-Bold",
              }}
            >
              {(
                (Number(payload?.originalPrice) || 0) +
                (Number(payload?.additionalCost) || 0)
              ).toFixed(2)}{" "}
              {payload?.currency} /{" "}
              <span style={{ fontSize: "20px", fontWeight: 400 }}>
                {payload?.durationType}
              </span>
            </Typography>
          </CardContent>
          <CardActions>
            <Button
              fullWidth
              variant="contained"
              onClick={() => onRegisterDomain(payload)}
              sx={{
                borderColor: "#3173B1",
                backgroundColor: "#3173B1",
                color: "white",
                fontSize: "14px",
                fontFamily: "Tajawal-Regular",
                borderRadius: "8px",
                padding: "12px",
              }}
            >
              {i18next.t(buttonText)}
            </Button>
          </CardActions>
        </Card>
      </DialogContent>
    </Dialog>
  );
};

export default CustomPopup;
